import {
  ADD_TAKEN_EVENT,
  FETCH_TAKEN_EVENTS_LOADING,
  FETCH_TAKEN_EVENTS_SUCCEEDED,
  type MedicationTakenEventAction,
  SYNC_TAKEN_EVENTS_LOADING,
  SYNC_TAKEN_EVENTS_SUCCEEDED,
} from '~shared/actions/medicationTakenEvents';
import { immutableBulkUpsert } from '~shared/helpers/immutableUpsert';
import { withRehydration } from '~shared/reducers/withRehydration';
import { type MedicationTakenEvent } from '~shared/types';
import { type PendingMedicationTakenEvent } from '~shared/types/medReminders';

export type StateMedicationTakenEvents = {
  takenEvents: MedicationTakenEvent[];
  pendingTakenEvents: PendingMedicationTakenEvent[];
  lastSyncTakenEventsSucceededAt: number;
  lastSyncTakenEventsAttemptedAt: number;
  syncTakenEventsAttemptCount: number;
  lastRequestSucceededAt: number;
  lastRequestAttemptedAt: number;
  requestAttemptCount: number;
};

export const initialState: StateMedicationTakenEvents = {
  takenEvents: [],
  pendingTakenEvents: [],
  lastSyncTakenEventsSucceededAt: 0,
  lastSyncTakenEventsAttemptedAt: 0,
  syncTakenEventsAttemptCount: 0,
  lastRequestSucceededAt: 0,
  lastRequestAttemptedAt: 0,
  requestAttemptCount: 0,
};

function filterPendingTakenEvents(pendingTakenEvents: PendingMedicationTakenEvent[], uuids: string[]) {
  const uuidMap = uuids.reduce<Record<string, boolean>>((obj, uuid) => {
    return { ...obj, [uuid]: true };
  }, {});
  return pendingTakenEvents.filter((takenEvent) => {
    return !uuidMap[takenEvent.uuid];
  });
}

const medicationTakenEvents = (
  state: StateMedicationTakenEvents = initialState,
  action: MedicationTakenEventAction,
): StateMedicationTakenEvents => {
  const { type } = action;

  switch (type) {
    case SYNC_TAKEN_EVENTS_SUCCEEDED: {
      const { payload } = action;
      const { uuids, takenEvents } = payload;

      return {
        ...state,
        pendingTakenEvents: filterPendingTakenEvents(state.pendingTakenEvents, uuids),
        takenEvents: immutableBulkUpsert({
          state: state.takenEvents,
          payload: takenEvents,
        }),
        lastSyncTakenEventsSucceededAt: Date.now(),
        syncTakenEventsAttemptCount: 0,
      };
    }

    case SYNC_TAKEN_EVENTS_LOADING:
      return {
        ...state,
        lastSyncTakenEventsAttemptedAt: Date.now(),
        syncTakenEventsAttemptCount: state.syncTakenEventsAttemptCount + 1,
      };

    case FETCH_TAKEN_EVENTS_LOADING: {
      return { ...state, lastRequestAttemptedAt: Date.now(), requestAttemptCount: state.requestAttemptCount + 1 };
    }

    case FETCH_TAKEN_EVENTS_SUCCEEDED: {
      const { payload } = action;

      return { ...state, takenEvents: payload, lastRequestSucceededAt: Date.now(), requestAttemptCount: 0 };
    }

    case ADD_TAKEN_EVENT: {
      const { payload } = action;
      return { ...state, pendingTakenEvents: [...state.pendingTakenEvents, payload] };
    }

    default:
      return state;
  }
};

export default withRehydration(medicationTakenEvents, initialState);
